var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4815 17.9474C43.1492 17.9474 43.483 18.2812 43.483 18.9489V25.2583C43.483 25.926 43.1492 26.2598 42.4815 26.2598H26.7579C26.4908 26.2598 26.3573 26.3934 26.3573 26.6605V42.0836C26.3573 42.7513 26.0235 43.0851 25.3558 43.0851H19.0463C18.3786 43.0851 18.0448 42.7513 18.0448 42.0836V26.6605C18.0448 26.3934 17.9113 26.2598 17.6442 26.2598H1.9206C1.25293 26.2598 0.919093 25.926 0.919093 25.2583V18.9489C0.919093 18.2812 1.25293 17.9474 1.9206 17.9474H17.6442C17.9113 17.9474 18.0448 17.8138 18.0448 17.5468V1.52271C18.0448 0.855039 18.3786 0.521202 19.0463 0.521202H25.3558C26.0235 0.521202 26.3573 0.855039 26.3573 1.52271V17.5468C26.3573 17.8138 26.4908 17.9474 26.7579 17.9474H42.4815Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.137a35ebb8d812a8dc810c21d6afadff.svg";
export { ForwardRef as ReactComponent };